import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { planTypeOptions } from 'src/api/types';
import { PlanType } from 'src/graphql/_generated';

interface PlanTypeSelectProps extends Omit<Props, 'value' | 'options'> {
  value: PlanType | undefined | null;
  onChange: (value: { label: string; value: PlanType }, meta: ActionMeta<any>) => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  restrictedTo?: PlanType[];
}

export const PlanTypeSelect: React.FC<PlanTypeSelectProps> = ({
  value,
  onChange,
  error,
  helperText,
  disabled,
  placeholder = 'Select',
  restrictedTo,
  ...rest
}) => {
  const options = restrictedTo
    ? planTypeOptions.filter((option) => restrictedTo.includes(option.value))
    : planTypeOptions;

  const selectedValue = value ? _.find(options, (o) => o.value === value) : null;

  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={selectedValue}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        inputId="plan-type-select"
        name="planType"
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
